/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_TestInputs */

const en_settings_test = /** @type {(inputs: Settings_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test`)
};

const he_settings_test = /** @type {(inputs: Settings_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בדיקה`)
};

/**
* | output |
* | --- |
* | "Test" |
*
* @param {Settings_TestInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_test = /** @type {((inputs?: Settings_TestInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_TestInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_test(inputs)
	return he_settings_test(inputs)
});